import type { LucideIcon } from "lucide-react";
import {
  Archive,
  Clock,
  FileEdit,
  Folder,
  Inbox,
  Send,
  ShieldAlert,
  Star,
  Trash2,
} from "lucide-react";
import { navFolderSlot } from "@/lib/mail/folderNavSections";
import {
  AURELIA_OUTBOX_FOLDER,
  AURELIA_SENDING_FOLDER,
  OUTBOX_FOLDER_LABEL,
  SCHEDULING_FOLDER_LABEL,
  SENDING_FOLDER_LABEL,
} from "@/lib/outbox/constants";
import {
  AURELIA_SNOOZED_FOLDER,
  SNOOZED_FOLDER_LABEL,
} from "@/lib/snooze/constants";
import {
  AURELIA_UNIFIED_INBOX_FOLDER,
  UNIFIED_INBOX_LABEL,
} from "@/lib/unified/constants";

export function folderIconFor(label: string, name: string): LucideIcon {
  if (name === AURELIA_UNIFIED_INBOX_FOLDER || label === UNIFIED_INBOX_LABEL) {
    return Inbox;
  }
  if (
    name === AURELIA_SNOOZED_FOLDER ||
    label === SNOOZED_FOLDER_LABEL ||
    navFolderSlot(name, label) === "snoozed"
  ) {
    return Clock;
  }
  if (name === AURELIA_OUTBOX_FOLDER || name === AURELIA_SENDING_FOLDER) {
    if (label === SENDING_FOLDER_LABEL) return Send;
    if (label === SCHEDULING_FOLDER_LABEL) return FileEdit;
    if (label === "Échec d'envoi") return Send;
    return Clock;
  }
  if (
    label === SENDING_FOLDER_LABEL ||
    label === SCHEDULING_FOLDER_LABEL ||
    label === OUTBOX_FOLDER_LABEL ||
    label === "Échec d'envoi"
  ) {
    return label === SCHEDULING_FOLDER_LABEL ? FileEdit : Send;
  }

  const key = `${name} ${label}`.toLowerCase();

  if (key.includes("inbox") || key.includes("réception") || key.includes("reception")) {
    return Inbox;
  }
  if (
    key.includes("sent") ||
    key.includes("envoy") ||
    key.includes("outbox")
  ) {
    return Send;
  }
  if (key.includes("draft") || key.includes("brouillon")) {
    return FileEdit;
  }
  if (key.includes("trash") || key.includes("corbeille") || key.includes("deleted")) {
    return Trash2;
  }
  if (key.includes("spam") || key.includes("junk") || key.includes("indésirable")) {
    return ShieldAlert;
  }
  if (key.includes("archive")) {
    return Archive;
  }
  if (key.includes("star") || key.includes("favori") || key.includes("flagged")) {
    return Star;
  }

  return Folder;
}
